import { render, staticRenderFns } from "./FavoritesCard.vue?vue&type=template&id=c843116e"
import script from "./FavoritesCard.vue?vue&type=script&lang=js"
export * from "./FavoritesCard.vue?vue&type=script&lang=js"
import style0 from "./FavoritesCard.vue?vue&type=style&index=0&id=c843116e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports